import { FormAtom } from "@impero-com/common/utils/form/formAtom/types";
import { useTranslation } from "@impero-com/common/utils/i18n";
import { useAtomValue } from "jotai";

import { FieldDrawerHeader } from "components/fieldBuilder/fieldDrawerHeader";

import { getConclusionFieldTypeInfo } from "./fieldBuilderUtils";
import { ControlConclusionField, SampleConclusionField } from "./schema";

interface ConclusionFieldDrawerHeaderProps<
    T extends ControlConclusionField | SampleConclusionField,
> {
    fieldAtom: FormAtom<T>;
}
export function ConclusionFieldDrawerHeader<
    T extends ControlConclusionField | SampleConclusionField,
>({ fieldAtom }: ConclusionFieldDrawerHeaderProps<T>) {
    const { t } = useTranslation();

    const field = useAtomValue(fieldAtom);
    const info = getConclusionFieldTypeInfo(t)(field.fieldType.type);
    return <FieldDrawerHeader fieldTypeInfo={info} />;
}
